// extracted by mini-css-extract-plugin
export var features = "features-module--features--3w8Ev";
export var featuresBody = "features-module--features-body--E3RAC";
export var feature = "features-module--feature--2qj_7";
export var featureHeader = "features-module--feature-header--2nrBu";
export var featureLink = "features-module--feature-link--2ag7N";
export var featureList = "features-module--feature-list--2fPrV";
export var featureItem = "features-module--feature-item--yiC9J";
export var featureItemCons = "features-module--feature-item--cons--1_MzW";
export var featureItemDesc = "features-module--feature-item-desc--F-MoG";